/**
 * Guide engine v3 - voice preference (#1026, epic #1020). Spec R9.
 *
 * The narration on/off + gender choice persists in localStorage (a v3-owned key,
 * mirroring the darkMode pattern). New-user default is voice ON + FEMALE. The
 * toggle flips between off and the last non-off gender. All access is guarded so
 * a storage-disabled browser degrades to the default rather than throwing.
 */

const VOICE_KEY = 'guideVoice';
const LAST_VOICE_KEY = 'guideVoiceLast';
const GENDERS = ['female', 'male'];
const VALID = ['female', 'male', 'off'];

export const DEFAULT_VOICE = 'female';

const read = (key) => {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
};

const write = (key, value) => {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    /* storage unavailable - degrade silently */
  }
};

/** Current voice ('female' | 'male' | 'off'); defaults to female. */
export const getVoice = () => {
  const v = read(VOICE_KEY);
  return VALID.includes(v) ? v : DEFAULT_VOICE;
};

/** Set the voice; ignores an invalid value. Remembers the last non-off gender. */
export const setVoice = (value) => {
  if (!VALID.includes(value)) return;
  if (value !== 'off') write(LAST_VOICE_KEY, value);
  write(VOICE_KEY, value);
};

/**
 * Toggle narration on/off. Off -> the last non-off gender (default female);
 * on -> off (remembering the current gender). Returns the new value.
 */
export const toggleVoice = () => {
  const cur = getVoice();
  if (cur === 'off') {
    const last = read(LAST_VOICE_KEY);
    const restored = GENDERS.includes(last) ? last : DEFAULT_VOICE;
    setVoice(restored);
    return restored;
  }
  setVoice('off');
  return 'off';
};
